import { api } from "..";

const endpoint = "/api/variance-reasons";

export const getVarianceReasonList = () => {
  return api.get(`${endpoint}`);
};
